<template>
  <h1>{{ $t('privacyPolicy') }}</h1>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  metaInfo() {
    return {
      title: this.$t('privacyPolicy'),
    };
  },
};
</script>

<i18n locale="en" lang="yaml">
  privacyPolicy: Privacy policy
</i18n>

<i18n locale="ru" lang="yaml">
  privacyPolicy: Политика конфиденциальности
</i18n>
